import { ENDPOINTS } from "@/constants/endpoints";
import { api } from "../network/api";
import type { BaseResponse } from "@/models/responses/base/baseResponse.response";
import type { InitiateAuthData } from "@/models/responses/auth/initiateAuth.response";
import type {
  CreateAuthorizedContactDto,
  InitiateAuthDto,
  VerifyOTPDto,
} from "@/models/dto";
import type { LoginDto } from "@/models/dto/login.dto";
import type { RegisterEmployerDto } from "@/models/dto";

const AuthService = {
  verifyLoginOTP: async function (dto: VerifyOTPDto) {
    const response = await api.post(ENDPOINTS.AUTH.VERIFY_LOGIN_OTP, dto);
    return response.data;
  },
  verifyRegistrationOTP: async function (dto: VerifyOTPDto) {
    const response = await api.post(
      ENDPOINTS.AUTH.VERIFY_REGISTRATION_OTP,
      dto
    );
    return response.data;
  },
  login: async function (dto: LoginDto) {
    const response = await api.post(ENDPOINTS.AUTH.LOGIN, dto);
    return response.data;
  },
  initiateAuth: async function (dto: InitiateAuthDto) {
    const response = await api.post<BaseResponse<InitiateAuthData>>(
      ENDPOINTS.AUTH.INITIATE_AUTH,
      dto
    );
    return response;
  },
  registerEmployer: async function (dto: RegisterEmployerDto) {
    const response = await api.post(ENDPOINTS.AUTH.REGISTER_EMPLOYER, dto);
    return response.data;
  },
  resendRegistrationOTPToEmployer: async function (employerCode: string) {
    const response = await api.post(
      ENDPOINTS.AUTH.RESEND_REGISTRATION_OTP_TO_EMPLOYER,
      { employerCode }
    );
    return response.data;
  },
  createAuthorizedContact: async function (dto: CreateAuthorizedContactDto) {
    const response = await api.post(ENDPOINTS.AUTH.ADD_AUTHORIZED_CONTACT, dto);
    return response.data;
  },
  resendAuthorizedContactVerificationOTP: async function (
    employerCode: string
  ) {
    const response = await api.post(
      ENDPOINTS.AUTH.RESEND_AUTHORIZED_CONTACT_OTP,
      { employerCode }
    );
    return response.data;
  },
  verifyAuthorizedContactVerificationOTP: async function (dto: VerifyOTPDto) {
    const response = await api.post(
      ENDPOINTS.AUTH.VERIFY_AUTHORIZED_CONTACT_OTP,
      dto
    );
    return response.data;
  },
  refreshSession: async function () {
    const response = await api.post(ENDPOINTS.AUTH.REFRESH_SESSION);
    return response.data;
  },
};

export default AuthService;
